import React from "react";
import { AuthRegisterComponent } from "./auth-register.component";

export const AuthRegisterPage = () => <AuthRegisterComponent />;
